import React, {useEffect, useState} from 'react';
import {Avatar, designSystemToken, Icon} from '@lightricks/react-design-system';
import checkImageValid from '@/utils/checkImageValid';
import OffPlatformBadge from '@/components/off-platform-badge/OffPlatformBadge';
import styles from './CreatorAvatar.module.scss';

type CreatorAvatarProps = {
  size?: '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | '2xs' | '3xs';
  profileImageUrl?: string;
  isGigCompleted?: boolean;
  isOffPlatform?: boolean;
};

function CreatorAvatar({
  size = '2xl',
  profileImageUrl,
  isGigCompleted = false,
  isOffPlatform = false,
}: CreatorAvatarProps) {
  const [imageUrlValid, setImageUrlValid] = useState(true);
  useEffect(() => {
    checkImageValid(profileImageUrl || '', setImageUrlValid);
  }, [profileImageUrl]);

  return (
    <div className={styles.creatorAvatarContainer}>
      <div className={styles.avatarWrapper}>
        <Avatar
          className={styles.creatorAvatar}
          size={size}
          src={imageUrlValid ? profileImageUrl : ''}
          type={profileImageUrl && imageUrlValid ? 'picture' : 'placeholder'}
          variant="circular"
          background={designSystemToken('semantic.bg.tertiary')}
          data-testid="avatar"
        />
        {isGigCompleted && (
          <span className={styles.completedBadge}>
            <Icon name="Actions-Accept" appearance="white" size="small" />
          </span>
        )}
        {isOffPlatform ? (
          <OffPlatformBadge variant="icon" className={styles.offPlatformMark} />
        ) : null}
      </div>
    </div>
  );
}

export default CreatorAvatar;
